module.exports = __webpack_public_path__ + "img/png-6.fdc5a3e1.png";